export enum CartModalKeys {
  CART = 'CART',
  GUIDANCE = 'GUIDANCE',
}
